import axios from 'axios';
import config from '@/config/env-constants';

function getProjectId() {
    if (config.currEnv === 'pallet-pooling') {
        return `${config.currEnv}`;
    } else {
        return `ayun-quantity-${config.currEnv}`;
    }
}

export default {
	baseUrl: `https://us-central1-${getProjectId()}.cloudfunctions.net`,

    editDiscrepancyReport(param) {
        let url = `${this.baseUrl}/editDiscrepancyReports`;
        return axios.post(url, {
            currUserId: param.currUserId,
            discrepancyReportArr: JSON.stringify(param.discrepancyReportArr)
        });
    }
}